import {useOutletContext} from "react-router-dom";
import {useEffect, useState} from "react";
import {AxiosRequestConfig} from "axios";

import {Client} from '../Api/Client';
import PageSections from "./PageSections";
import BackButton from "./BackButton";

function Page({endpoint, showBackButton = false}: any) {
    const [setTitle, setCount] = useOutletContext<any>();
    const [sections, setSections] = useState([]);

    async function getPageData(endpoint: string, config: AxiosRequestConfig) {
        Client.get(endpoint, config)
            .then((response) => {
                window.scrollTo(0, 0);
                setTitle(response.data.title ?? '');
                setCount(response.data.count ?? null);
                setSections(response.data.sections ?? []);
            })
            .catch((e) => console.log(e.message))
    }

    useEffect(() => {
        const abortController = new AbortController();

        getPageData(endpoint, {signal: abortController.signal});

        return () => abortController.abort();
    }, [endpoint]);

    return (
        <div className="relative">
            {showBackButton &&
                <div className="fixed left-4 bottom-4 z-20 xl:hidden">
                    <BackButton/>
                </div>
            }

            {sections?.length
                ? <PageSections sections={sections} />
                : <></>
            }
        </div>
    );
}

export default Page;